import { useTranslation } from "react-i18next";

interface SidebarCollapsedProps {
  onToggleCollapse: () => void;
  unitStats: {
    driving: number;
    ralenti: number;
    stopped: number;
    offline: number;
  };
  totalVehicles: number;
  themeClasses: {
    bg: string;
    border: string;
    text: string;
    textSecondary: string;
    buttonHover: string;
  };
}

// Panel contraído: sólo los conteos por estado y el total, del mismo tamaño
// (Daniel, 30-oct). Los bloques azules de vehículos, remolques y viajes
// competían con el semáforo y repetían lo que dice el panel abierto.
export default function SidebarCollapsedContent({
  onToggleCollapse,
  unitStats,
  totalVehicles,
  themeClasses,
}: SidebarCollapsedProps) {
  const { t } = useTranslation("lite");

  const stats = [
    { count: unitStats.driving, color: "bg-primary-500", tooltip: t("tooltips.drivingUnits", { count: unitStats.driving }) },
    { count: unitStats.ralenti, color: "bg-amber-400", tooltip: t("tooltips.idleUnits", { count: unitStats.ralenti }) },
    { count: unitStats.stopped, color: "bg-red-400", tooltip: t("tooltips.stoppedUnits", { count: unitStats.stopped }) },
    { count: unitStats.offline, color: "bg-gray-400", tooltip: t("tooltips.offlineUnits", { count: unitStats.offline }) },
  ];

  return (
    <div className={`w-16 ${themeClasses.bg} border-r ${themeClasses.border} flex flex-col items-center h-full py-3 gap-3`}>
      <button
        onClick={onToggleCollapse}
        className={`size-8 grid place-items-center rounded-[10px] transition-colors ${themeClasses.buttonHover} ${themeClasses.textSecondary}`}
        title={t("sidebar.expandSidebar")}
        aria-label={t("sidebar.expandSidebar")}
      >
        <i className="ri-menu-unfold-line text-[17px]" aria-hidden />
      </button>

      <div className="flex flex-col items-center gap-2.5">
        {stats.map((stat) => (
          <div key={stat.color} className="flex flex-col items-center gap-1" title={stat.tooltip}>
            <span className={`size-2 rounded-full ${stat.color}`} />
            <span className={`text-xs font-semibold tabular-nums ${themeClasses.text}`}>{stat.count}</span>
          </div>
        ))}
        <span aria-hidden className={`w-5 border-t ${themeClasses.border}`} />
        <div className="flex flex-col items-center" title={t("sidebar.total")}>
          <span className={`text-xs font-semibold tabular-nums ${themeClasses.text}`}>{totalVehicles}</span>
          <span className={`text-[10px] leading-3 ${themeClasses.textSecondary}`}>{t("sidebar.total")}</span>
        </div>
      </div>
    </div>
  );
}
